export enum IssueTrackerCode {
  Other,
  SierrawirelessUnauthorized,
  CradlepointUnauthorized,
  InhandUnauthorized,
  PepwaveUnauthorized,
  SkyswitchPbxUnauthorized,
  SkyswitchTelcoUnauthorized,
  E911ProvisioningError,
  CradlepointCantGetInterfaceData,
  BoBoOverridesNotFound,
  UpdateServiceLocationFailed,
  CancelServiceFailed,
  DeleteDidFromTelcoFailed,
  ConfigureDidFailed,
  ConfigureDide911Failed,
  RoutingDidFailed,
  CreateServicesFailed,
}
